import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const BackButton = styled.div`
a {		
	display: flex;
  justify-content: space-between;
  align-items: center;
	color: ${Variables.colors.complementary_700};
	text-decoration: none;
	i.right-side-icon {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 0 0 0 8px;
		cursor: pointer;
		&:before {
			color: ${Variables.colors.complementary_700};
			margin-left: 0;
			font-size: 24px;
		}
		&:hover {
			background-color: ${Variables.colors.complementary_300};
		}
	}
	span {
	  cursor: pointer;
	}
}
`;	
